import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import { photoUrl } from "../lib/api";

const PAW = "https://customer-assets-7cd3h4nn.emergentagent.net/job_critter-classifieds/artifacts/r4i8kh4r_paw-logo.png";

const LABELS = { admin: "ADMIN", moderator: "MODERATOR" };
const TAG_LABELS = { admin: "Official · Admin", moderator: "Official · Moderator" };

// Compact "official" pill with the paw logo, for staff on public listings/profiles.
export const StaffTag = ({ role, className = "" }) => {
  if (role !== "admin" && role !== "moderator") return null;
  return (
    <span
      data-testid={`staff-tag-${role}`}
      className={`inline-flex items-center gap-1 bg-[#12234A] text-white text-[11px] font-semibold px-2 py-0.5 rounded-full ${className}`}
    >
      <img src={PAW} alt="" className="h-3.5 w-3.5 object-contain" /> {TAG_LABELS[role]}
    </span>
  );
};

// Shows a paw-logo staff badge for admins/moderators, otherwise the user's photo.
export const RoleAvatar = ({ user, size = 40, className = "" }) => {
  const role = user?.role;
  if (role === "admin" || role === "moderator") {
    const label = LABELS[role];
    const labelSize = Math.max(5, size * (role === "admin" ? 0.17 : 0.115));
    return (
      <div
        data-testid={`role-avatar-${role}`}
        className={`relative rounded-full overflow-hidden bg-[#12234A] border-2 border-slate-200 shrink-0 ${className}`}
        style={{ width: size, height: size }}
      >
        <img
          src={PAW}
          alt=""
          className="absolute left-1/2 -translate-x-1/2 object-contain"
          style={{ top: size * 0.1, width: size * 0.62, height: size * 0.62 }}
        />
        <span
          className="absolute bottom-0 inset-x-0 bg-[#F5551E] text-white font-extrabold text-center uppercase tracking-tight"
          style={{ fontSize: labelSize, lineHeight: 1.25, paddingTop: 1, paddingBottom: 1 }}
        >
          {label}
        </span>
      </div>
    );
  }
  return (
    <Avatar className={className} style={{ width: size, height: size }}>
      <AvatarImage src={photoUrl(user?.picture)} />
      <AvatarFallback className="bg-[#12234A] text-white" style={{ fontSize: size * 0.4 }}>
        {user?.name?.[0]?.toUpperCase()}
      </AvatarFallback>
    </Avatar>
  );
};
